import { keepTrackApi } from '@app/keepTrackApi';
import { Line } from './line';
export class SatToRefLine extends Line {
    sat;
    ref2_;
    constructor(sat, ref2, color) {
        super();
        this.sat = sat;
        this.ref2_ = ref2;
        this.validateColor(color);
        this.color_ = color;
    }
    update() {
        const posData = keepTrackApi.getDotsManager().positionData;
        const position = {
            x: posData[this.sat.id * 3],
            y: posData[this.sat.id * 3 + 1],
            z: posData[this.sat.id * 3 + 2],
        };
        const satArr = [position.x, position.y, position.z];
        this.updateVertBuf([satArr, this.ref2_]);
    }
}
